const text = (value) => typeof value === 'string' ? value.trim() : '';

// App is the Android release collection; legacy records may call the package a bundleId.
export const getAndroidPackageName = (app) =>
  text(app.packageName) || text(app.packageId) || text(app.bundleId) ||
  (/^[A-Za-z]\w*(\.[A-Za-z]\w*)+$/.test(app.id || '') ? app.id : '');

export const getAndroidPackages = (apps) => {
  const packages = new Map();
  apps.forEach((app) => {
    const packageName = getAndroidPackageName(app);
    if (!packageName) return;
    if (!packages.has(packageName)) packages.set(packageName, { packageName, apps: [] });
    packages.get(packageName).apps.push({
      id: app.id,
      name: app.appName || app.id,
      managed: app.id.endsWith('-managed'),
      bundleId: text(app.bundleId),
    });
  });
  return [...packages.values()].sort((a, b) => a.packageName.localeCompare(b.packageName));
};


export const getAndroidRegistrationState = (record, fingerprint) => {
  const normalizeFingerprint = (value) => text(value).replace(/:/g, '').toLowerCase();
  const google = record?.google;
  if (!fingerprint || google?.scope !== 'package-and-certificate' ||
      normalizeFingerprint(google.certificateFingerprint) !== normalizeFingerprint(fingerprint)) return 'UNKNOWN';
  return ['REGISTERED', 'NOT_REGISTERED', 'REGISTERED_WITH_ANOTHER_CERTIFICATE_FINGERPRINT'].includes(google.state)
    ? google.state : 'UNKNOWN';
};
